var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.308 19.5c-.505 0-.933-.175-1.283-.525a1.745 1.745 0 01-.525-1.283V6.308c0-.505.175-.933.525-1.283.35-.35.778-.525 1.283-.525h15.384c.505 0 .933.175 1.283.525.35.35.525.778.525 1.283v11.384c0 .505-.175.933-.525 1.283-.35.35-.778.525-1.283.525H4.308zM12 12.392a.846.846 0 00.248-.037c.082-.025.162-.06.239-.103l7.152-4.579a.59.59 0 00.242-.274.64.64 0 00.042-.355.588.588 0 00-.338-.514.614.614 0 00-.645.03L12 11 5.06 6.56c-.217-.132-.43-.143-.64-.032a.602.602 0 00-.343.507.705.705 0 00.042.375.51.51 0 00.243.263l7.152 4.579c.076.043.156.078.238.103a.846.846 0 00.248.037z",
    fill: "currentColor"
  })));
}
SvgMailFilled.displayName = 'MailFilled';
export default SvgMailFilled;